// extracted by mini-css-extract-plugin
module.exports = {"section":"aboutSection-module--section--3OsuZ","header":"aboutSection-module--header--38wuK","text":"aboutSection-module--text--1xPpl"};